import React from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import shiftIconSVG from '../../assets/icons/shift-icon.svg'
import classroomPeoplesSVG from '../../assets/icons/classroom-peoples-icon.svg'
import soloPeopleSVG from '../../assets/icons/solo-people-icon.svg'
import { shiftOptions } from '../../utils/constants'
import Button from '../button/Button'
import Modal from '../modal/Modal'
import StyledSVG from '../shared/StyledSVG'
import { occupationsObject } from '../../utils/dicts'
// import archiveIcon from '../../assets/icons/archive-icon.svg'
import mediationAvatarSVG from '../../assets/icons/mediation-message.svg'
import groupRoomIcon from '../../assets/icons/message-group.svg'
import UserAvatar from '../shared/UserAvatar'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    padding: 18,
    borderLeft: '1px solid #CED6E0',
    position: 'relative'
  },
  close_section: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8,
    '& h1': {
      color: '#4D5E80',
      fontWeight: 600,
      fontSize: 18
    }
  },
  profile_section: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16
  },
  room_identification: {
    marginBottom: 18,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    '& .room_name': {
      margin: 0,
      fontSize: 18,
      fontWeight: 600
    },
    '& .room_description': {
      color: '#9F9F9F',
      fontSize: 14,
      fontWeight: 400
    }
  },
  horizontal_bar: {
    height: 0,
    width: '100%',
    borderBottom: '1px solid #868E964D'
  },
  room_participants_section: {
    margin: '18px 0px 18px 0px',
    minHeight: 100,
    maxHeight: 150,
    height: 'auto',
    overflowY: 'scroll',
    resize: 'none',
    overflow: 'hidden'
  },
  edit_room_participants: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
    '& svg': {
      fill: '#386093'
    },
    '& p': {
      fontSize: 14,
      fontWeight: 500,
      color: '#386093'
    }
  },
  room_participant: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& p': {
      fontWeight: 500,
      fontSize: 10
    }
  },
  room_participants: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column'
  },
  close_room: {
    cursor: 'pointer',
    backgroundColor: '#EF7B8E',
    borderRadius: 8,
    width: 220,
    gap: 8,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      fontSize: 14,
      fontWeight: 700
    }
  },
  close_room_wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    bottom: 50
  },
  cancelBtn: {
    backgroundColor: '#EF7C8F',
    width: 136,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  confirmBtn: {
    backgroundColor: '#386093',
    color: '#FFFF',
    width: 165,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  text_modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  participant_infos: {
    margin: '12px 0px 18px 0px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  p_info: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    '& h1': {
      fontWeight: 600,
      fontSize: 16,
      color: '#555555',
      margin: 0
    }
  },
  p_info_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    '& .items': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      gap: 4,
      '& p': {
        paddingLeft: 25,
        fontWeight: 400,
        fontSize: 14,
        margin: 0
      }
    }
  },
  room_description: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    margin: '12px 0px 18px 0px',
    '& h1': {
      fontWeight: 600,
      fontSize: 16,
      margin: 0
    },
    '& p': {
      fontWeight: 400,
      fontSize: 12,
      margin: 0,
      minHeight: 50,
      maxHeight: 80,
      height: 'auto',
      overflowY: 'scroll',
      resize: 'none',
      overflow: 'hidden',
      wordBreak: 'break-word'
    }
  }
}))

const RoomDetailsView = props => {
  const { setRoomDetails, currentRoom, currentUser, deleteChat } = props
  const history = useHistory()
  const [finishRoomModal, setFinishRoomModal] = React.useState(false)
  const [roomData, setRoomData] = React.useState({
    name: '',
    photo: null,
    description: '',
    otherParticipant: null
  })
  const classes = useStyles()

  const uniqueShifts = [
    ...new Set(
      roomData.otherParticipant?.user?.classrooms
        .map(c => c.shift)
        .filter(shift => shift && shift !== 'undefined')
    )
  ]
  // const isMediationMessage =
  //   currentRoom?.mediation_message_id && currentRoom?.room_type === 'group'

  React.useEffect(
    () => {
      if (currentRoom?.room_type === 'private') {
        const otherParticipant = currentRoom?.room_participants?.find(
          item =>
            +item?.user?.fractal_id !== +currentUser?.attributes.fractal_id
        )
        setRoomData(prev => ({
          ...prev,
          name: otherParticipant?.user?.name,
          description: occupationsObject[otherParticipant.occupation_name],
          otherParticipant: otherParticipant
        }))
      } else {
        const name = currentRoom?.name
        setRoomData(prev => ({
          ...prev,
          name,
          description: `Grupo - ${
            currentRoom.room_participants?.length
          } membros`,
          photo: currentRoom?.mediation_message_id
            ? mediationAvatarSVG
            : currentRoom.cover_image_url
              ? currentRoom.cover_image_url
              : groupRoomIcon
        }))
      }
    },
    [currentRoom.room_type]
  )

  const handleDeleteRoom = () => {
    deleteChat(currentRoom.id)
    setTimeout(() => {
      history.push('/rooms')
    }, 500)
  }

  return (
    <div className={classes.root}>
      <div className={classes.close_section}>
        <CloseIcon
          style={{ cursor: 'pointer' }}
          onClick={() => setRoomDetails(prev => ({ ...prev, isOpen: false }))}
        />
        <h1>Dados da conversa</h1>
      </div>
      <div className={classes.profile_section}>
        <UserAvatar
          avatarStyle={{
            width: 130,
            height: 130
          }}
          avatarUrl={roomData.photo}
          userName={roomData.name}
          withoutUserName
        />
        <div className={classes.room_identification}>
          <h1 className='room_name'>{roomData.name}</h1>
          <span className='room_description'>{roomData.description}</span>
        </div>
      </div>
      {currentRoom.room_type === 'private' && (
        <>
          <div className={classes.participant_infos}>
            {roomData?.otherParticipant?.user?.children?.length > 0 && (
              <div className={classes.p_info_wrapper}>
                <div className={classes.p_info}>
                  <StyledSVG src={soloPeopleSVG} width={18} height={18} />
                  <h1>Aluno</h1>
                </div>
                <div className='items'>
                  {roomData.otherParticipant?.user.children.map(item => {
                    return <p key={item.id}>{item.name}</p>
                  })}
                </div>
              </div>
            )}
            {roomData?.otherParticipant?.user?.classrooms?.length > 0 && (
              <div className={classes.p_info_wrapper}>
                <div className={classes.p_info}>
                  <StyledSVG src={classroomPeoplesSVG} width={18} height={18} />
                  <h1>Turma</h1>
                </div>
                <div className='items'>
                  {roomData.otherParticipant?.user?.classrooms.map(item => {
                    return <p key={item.id}>{item.name}</p>
                  })}
                </div>
              </div>
            )}
            {roomData?.otherParticipant?.user?.classrooms?.length > 0 && (
              <div className={classes.p_info_wrapper}>
                <div className={classes.p_info}>
                  <StyledSVG src={shiftIconSVG} width={18} height={18} />
                  <h1>Turno</h1>
                </div>
                <div className='items'>
                  {uniqueShifts.map(item => {
                    return (
                      <p key={item.id}>
                        {shiftOptions?.find(sft => sft?.value === item)?.label}
                      </p>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
        </>
      )}
      {currentRoom.room_type === 'group' && (
        <>
          {currentRoom.description && (
            <div className={classes.room_description}>
              <h1>Descrição</h1>
              <p>{currentRoom.description}</p>
            </div>
          )}
          <div className={classes.horizontal_bar} />
          <div className={classes.room_participants_section}>
            {/* <div className={classes.edit_room_participants}>
              <p>Editar</p>
              <ArrowBackIos style={{transform: 'rotate(180deg)'}}/>
            </div> */}
            <div
              style={{
                minHeight: currentRoom.room_participants.length / 2 * 35
              }}
              className={classes.room_participants}
            >
              {currentRoom.room_participants.length > 0 &&
                currentRoom.room_participants.map(item => {
                  return (
                    <div key={item.id} className={classes.room_participant}>
                      <UserAvatar
                        avatarStyle={{
                          width: 24,
                          height: 24
                        }}
                        userName={item?.user?.name}
                        withoutUserName
                      />
                      <p>{item?.user?.name}</p>
                    </div>
                  )
                })}
            </div>
          </div>
        </>
      )}
      <div className={classes.horizontal_bar} />
      {/* {isMediationMessage && (
        <div className={classes.close_room_wrapper}>
          <div
            onClick={() => setFinishRoomModal(true)}
            className={classes.close_room}
          >
            <StyledSVG src={archiveIcon} width={18} height={18} />
            <p>Finalizar intervenção</p>
          </div>
        </div>
      )} */}
      <Modal
        open={finishRoomModal}
        handleClose={() => setFinishRoomModal(prev => !prev)}
      >
        <div className={classes.text_modal}>
          <h1>Atenção!</h1>
          <h2>Ao confirmar a sala atual será desativada.</h2>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
          <Button
            className={classes.cancelBtn}
            onClick={() => setFinishRoomModal(false)}
          >
            Cancelar
          </Button>
          <Button
            onclick={() => handleDeleteRoom()}
            className={classes.confirmBtn}
          >
            Confirmar
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default RoomDetailsView
